import styled from 'styled-components';

const StyledVideo = styled.video`
  width: auto;
  height: 100%;
  max-width: 100%;
  max-height: inherit;
  object-fit: contain;
  border-radius: 5px;
`;

export {
  StyledVideo,
};
